import React from 'react';
import { TrendingUp, Award, Users, Shield } from 'lucide-react';

const ShopwareCompetence = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-white">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="inline-block bg-blue-100 text-blue-700 text-sm font-semibold px-3 py-1 rounded-full mb-4">
              Shopware Expertise seit 2012
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Shop programmieren lassen von echten Shopware-Experten
            </h2>
            
            <p className="text-lg text-gray-600 mb-8">
              Als zertifizierte <strong className="text-blue-700">Shopware Agentur</strong> mit jahrelanger Erfahrung 
              kennen wir die Plattform in- und auswendig. Wir haben bereits zahlreiche erfolgreiche 
              B2B und B2C Shops entwickelt und sorgen auch bei deinem Projekt für maximalen Erfolg.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-blue-100 p-3 flex-shrink-0">
                  <TrendingUp className="h-5 w-5 text-blue-700" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">Nachweisbare Erfolge</h3>
                  <p className="text-gray-600">
                    Unsere Shopware-Projekte erzielen im Schnitt 35% höhere Conversion-Raten und 42% mehr Umsatz 
                    als der Branchendurchschnitt – durch optimierte User Experience und durchdachte Verkaufsstrategien.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-blue-100 p-3 flex-shrink-0">
                  <Award className="h-5 w-5 text-blue-700" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">Zertifizierter Partner</h3>
                  <p className="text-gray-600">
                    Als offizieller Shopware Business Partner haben wir Zugang zu exklusivem Support, 
                    neuesten Updates und Insider-Wissen – für optimale Entwicklung deines Online-Shops.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-blue-100 p-3 flex-shrink-0">
                  <Users className="h-5 w-5 text-blue-700" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">Erfahrenes Team</h3>
                  <p className="text-gray-600">
                    Unsere Shopware-Entwickler bringen durchschnittlich 7+ Jahre Erfahrung mit und haben 
                    bereits über 100 erfolgreiche Shop-Projekte umgesetzt – von kleinen B2C-Shops bis zu 
                    komplexen B2B-Plattformen.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-blue-100 p-3 flex-shrink-0">
                  <Shield className="h-5 w-5 text-blue-700" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-1">Qualitätsversprechen</h3>
                  <p className="text-gray-600">
                    Wir liefern technisch einwandfreie, performante und sichere Shopware-Shops mit 
                    sauberem Code und umfassender Dokumentation – für langfristigen, nachhaltigen Erfolg.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white rounded-xl shadow-lg p-6 transform hover:-translate-y-2 transition-transform duration-300">
                <div className="text-3xl font-bold text-blue-600 mb-2">10+</div>
                <p className="text-gray-700">Jahre Shopware-Erfahrung</p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6 transform hover:-translate-y-2 transition-transform duration-300">
                <div className="text-3xl font-bold text-blue-600 mb-2">120+</div>
                <p className="text-gray-700">Erfolgreiche Shop-Projekte</p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6 transform hover:-translate-y-2 transition-transform duration-300">
                <div className="text-3xl font-bold text-blue-600 mb-2">98%</div>
                <p className="text-gray-700">Zufriedene Kunden</p>
              </div>
              
              <div className="bg-white rounded-xl shadow-lg p-6 transform hover:-translate-y-2 transition-transform duration-300">
                <div className="text-3xl font-bold text-blue-600 mb-2">5⭐</div>
                <p className="text-gray-700">Durchschnittliche Bewertung</p>
              </div>
            </div>
            
            <div className="absolute -top-12 -right-12 bg-gradient-to-br from-blue-600 to-indigo-600 text-white rounded-xl shadow-lg p-6 z-10 hidden lg:block">
              <div className="text-2xl font-bold mb-1">Shopware 6</div>
              <p className="text-sm opacity-90">Certified Business Partner</p>
            </div>
            
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-blue-100 rounded-full z-0 hidden lg:block"></div>
          </div>
        </div>
        
        <div className="mt-16 lg:mt-24 bg-blue-600 rounded-xl text-white p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">+45%</div>
              <p className="opacity-90">Höhere Conversion</p>
            </div>
            
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">+68%</div>
              <p className="opacity-90">Mehr Seitenaufrufe</p>
            </div>
            
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">-32%</div>
              <p className="opacity-90">Weniger Absprünge</p>
            </div>
          </div>
          
          <div className="text-center mt-8">
            <p className="text-lg">
              Durchschnittliche Ergebnisse unserer Shopware-Entwicklungsprojekte im Vergleich zu Vor-Relaunch
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopwareCompetence; 